export default __webpack_public_path__ + "static/media/qovurma_lagman.4f7c0b2f.png";